<template>
    <div>
        <b-form>
            <b-col cols="12" class="d-flex justify-content-end">
                <b-button variant="primary" @click="adicionarItem">
                    +
                </b-button>
            </b-col>

            <b-table ref="bTable" responsive class="mt-2" small :items="contratoForm.responsaveisFiscais" :fields="fields" hover>

                <template v-slot:cell(dataInicial)="data">
                    <lg-form-date class="mt-2 mb-2" invalidFeedback=" " description=" " v-model="data.item.dataFinal"
                        label=" " />
                </template>

                <template v-slot:cell(observacao)="data">
                    <lg-form-input class="mt-2 mb-2" v-model="data.item.observacao" label=" " description=" " />
                </template>
                <template v-slot:cell(situacao)="data">
                    <lg-form-const-select class="mt-2 mb-2" label="" v-model="data.item.situacao"
                        :options="opcoesSituacao" />
                </template>

                <template v-slot:cell(dataFinal)="data">
                    <lg-form-date class="mt-2 mb-2" invalidFeedback=" " description=" " v-model="data.item.dataInicial"
                        label=" " />
                </template>

                <template v-slot:cell(tipoFiscal)="data">
                    <LgFinderPageTipoFiscal :id="'finderTipoResponsavelFiscalForm' + data.index" class="mt-2 mb-2"
                        label=" " v-model="data.item.tipoFiscal"
                        @onselect="function (tipo) { setTipoFiscal(data.item, tipo) }" :prefix="prefix" />
                </template>

                <template v-slot:cell(pessoa)="data">
                    <lg-finder-page-pessoa class="mt-2 mb-2" :id="'finderPessoaResponsavelFiscalForm' + data.index"
                        @onselect="function (pessoa) { handleSelectPessoa(data.item, pessoa) }" invalidFeedback=" "
                        :prefix="prefix" v-model="data.item.pessoa" label=" ">
                    </lg-finder-page-pessoa>
                </template>
                <template v-slot:cell(acoes)="data">
                    <b-button v-if="!isEditMode" size="sm" pill variant="danger" @click="removerResponsavelFiscal(data.index)">
                        <b-icon icon="trash" />
                    </b-button>
                </template>
            </b-table>
        </b-form>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFinderPageTipoFiscal from "@/components/Finders/LgFinderPageTipoFiscal.vue";


export default {
    name: "ResponsaveisFiscaisForm",
    mixins: [validationMixin],
    components: {
        LgFinderPageTipoFiscal,
        LgFinderPagePessoa,
        LgFormDate,
        LgFormInput,
        LgFormConstSelect
    },
    props: {
        prefix: {
            type: String,
            default: ""
        },

        contratoFormProp: {
            type: Object,
            required: true,
        },
        isEditMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            contratoForm: this.contratoFormProp,
            fields: [
                { key: "tipoFiscal", label: "Tipo Fiscal" },
                { key: "pessoa", label: "Pessoa" },
                { key: "dataInicial", label: "Data Inicial" },
                { key: "dataFinal", label: "Data Final" },
                { key: "observacao", label: "Observação" },

                { key: "situacao", label: "Situação", class: "text-center" },
                { key: "acoes", label: "Ações", class: "text-center" },
            ],
            opcoesSituacao: [
                { value: 1, text: "Ativo" },
                { value: 0, text: "Inativo" },
            ],
        };
    },
    methods: {
        adicionarItem() {
            this.contratoForm.responsaveisFiscais.push({ tipoFiscal: {}, pessoa: {}, observacao: "", dataInicial: "", dataFinal: "", situacao: 1, });
        },
        setTipoFiscal(item, tipo) {
            item.tipoFiscal = tipo;

        },
        removerResponsavelFiscal(index) {
            this.contratoForm.responsaveisFiscais.splice(index, 1);
        },
        handleSelectPessoa(item, pessoa) {
            item.pessoa = pessoa;
        },
    },
};
</script>

<style scoped>
.mt-2 {
    margin-top: 0.5rem;
}

.ml-2 {
    margin-left: 0.5rem;
}

.mt-3 {
    margin-top: 1rem;
}
</style>
